import React from "react";

function CheckIcon() {
  return (
    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-[#29CC7A]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-3.5 h-3.5 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={3}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>
  );
}

export function LearnCard({ title, description }) {
  return (
    <div className="flex gap-4 rounded-[4px] border-l-[3px] border-[#29CC7A] bg-white p-[24px]">
      <div className="">
        <CheckIcon />
      </div>

      <div className="">
        <h3 className="font-bold text-[16px] leading-[24px] text-[#1E1B2E] mb-2 ">
          {title}
        </h3>
        <p className="font-normal text-[16px] leading-[28px] text-[#1E1B2E]">
          {description}
        </p>
      </div>
    </div>
  );
}

export default LearnCard;
